/**
 * /fuel/success — Post-Stripe confirmation, reads order status.
 */
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Loader2, CheckCircle2 } from 'lucide-react';
import api from '../services/api';

const FuelSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!sessionId) { setErr('Missing session id'); return; }
    api.get(`/fuel/order/${sessionId}`).then((r) => setOrder(r.data.order)).catch((e) => setErr(e?.response?.data?.detail || 'Order not found'));
  }, [sessionId]);

  if (err) return <div className="min-h-screen bg-[#0B0E14] flex items-center justify-center text-white px-6"><div className="text-center"><p>{err}</p><Link to="/fuel" className="mt-4 inline-block text-emerald-400 underline">Back to FUEL</Link></div></div>;
  if (!order) return <div className="min-h-screen bg-[#0B0E14] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-emerald-500" /></div>;

  return (
    <div className="min-h-screen bg-[#0B0E14] text-white pt-16 pb-24 px-4" data-testid="fuel-success">
      <div className="container mx-auto max-w-2xl">
        <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-4" />
        <h1 className="text-3xl md:text-4xl font-black uppercase text-center">Order Confirmed</h1>
        <p className="text-center text-zinc-400 mt-2">Coach B will hand-deliver on each selected date.</p>

        <div className="mt-8 border-2 border-emerald-500 bg-emerald-500/[0.05] p-5">
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div className="text-zinc-500">Student</div><div className="font-black text-right">{order.student_name}</div>
            <div className="text-zinc-500">Days</div><div className="font-black text-right">{order.days_count}</div>
            <div className="text-zinc-500">Total</div><div className="font-black text-right text-emerald-400">${order.total.toFixed(2)}</div>
            {order.discount > 0 && (<><div className="text-emerald-400">10% Multi-Day Savings</div><div className="text-right text-emerald-400">– ${order.discount.toFixed(2)}</div></>)}
          </div>
          <div className="text-[10px] uppercase tracking-widest font-black text-zinc-500 mt-4 mb-1">Delivery Dates</div>
          <div className="font-mono text-[12px] text-zinc-300 leading-relaxed">{order.dates.join(' · ')}</div>
          {order.allergies && order.allergies.toLowerCase() !== 'none' && (
            <div className="mt-3"><span className="text-[10px] font-black uppercase tracking-widest" style={{ color: '#FF0000' }}>Allergies noted:</span> <span className="text-red-300">{order.allergies}</span></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FuelSuccess;
